export default __webpack_public_path__ + "static/media/batch_summary_pdf_image.f934426e.png";